import { Box, Button, Tooltip } from '@shared/components';

interface QSetCheckPublishedButtonProps {
  disabled?: boolean;
  onClick: () => void;
}

export default function QSetCheckPublishedButton(props: Readonly<QSetCheckPublishedButtonProps>) {
  const { disabled, onClick } = props;

  return (
    <Tooltip title='กรุณาเลือกชุดข้อสอบอย่างน้อย 2 รายการ' disableHoverListener={!disabled}>
      {/* NOTE: This Box is necessary for triggering tooltip display with a disabled element since tooltip doesn't support disabled element */}
      <Box>
        <Button
          disabled={disabled}
          size='small'
          color='secondary'
          variant='outlined'
          onClick={onClick}
        >
          Check Published
        </Button>
      </Box>
    </Tooltip>
  );
}
